import { render, staticRenderFns } from "./nextDialog.vue?vue&type=template&id=3ffd7873&scoped=true"
import script from "./nextDialog.vue?vue&type=script&lang=js"
export * from "./nextDialog.vue?vue&type=script&lang=js"
import style0 from "./nextDialog.vue?vue&type=style&index=0&id=3ffd7873&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ffd7873",
  null
  
)

export default component.exports